module.exports = __webpack_public_path__ + "static/img/83066A_R_all_20170816_fit.e42df3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/83066A_R_all_20170816_fit.png
// module id = QE28
// module chunks = 0